import React, { ReactElement } from 'react'
import { Link as RouterLink } from 'react-router-dom'

import { Trans } from '@lingui/macro'

import { websiteRoutes } from '../../../../../../shared/constants'
import { getComplaintsEmails } from '../../../../../../shared/get-emails'
import { Text } from '../../styled'
import { Link, TextTitle } from './styles'
import { getLegalInfoComponent, getRestrictedJurisdictionsComponent } from './utils'

const complaintsEmail = getComplaintsEmails()
const LegalInfo = getLegalInfoComponent()
const RestrictedJurisdictions = getRestrictedJurisdictionsComponent()

export function Content(): ReactElement {
  return (
    <>
      <TextTitle textAlign="left">
        <Trans>Risk Warning</Trans>
      </TextTitle>
      <Text textAlign="left">
        <Trans>
          Leveraged trading in foreign currency contracts, contracts for difference or other off-exchange products
          carries a high level of risk and may not be suitable for everyone. Before trading, you are strongly advised to
          read and ensure that you understand the relevant risk disclosures. There is a substantial risk that you may
          lose all of your initial investment. We advise you to consider whether trading leveraged products is
          appropriate for you in light of your own personal circumstances. We recommend that you seek independent
          financial advice and ensure that you fully understand all risks involved before trading.
        </Trans>
      </Text>
      <TextTitle textAlign="left">
        <Trans>Legal Information</Trans>
      </TextTitle>
      <LegalInfo />
      <TextTitle textAlign="left">
        <Trans>Restricted Jurisdictions</Trans>
      </TextTitle>
      <RestrictedJurisdictions />
      <Text textAlign="left">
        <Trans>
          Please review the company policies and legal documents{' '}
          <RouterLink to={websiteRoutes.legalDocuments}>here</RouterLink>. <br />
          For complaints please email us at <Link href={`mailto:${complaintsEmail}`}>{complaintsEmail}</Link>
        </Trans>
      </Text>
    </>
  )
}
